function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 12.125h1.75v1.75h-1.75v-1.75zm0-7h1.75v5.25h-1.75v-5.25zM9.491.75C4.661.75.75 4.67.75 9.5s3.911 8.75 8.741 8.75c4.839 0 8.759-3.92 8.759-8.75S14.33.75 9.491.75zM9.5 16.5c-3.867 0-7-3.133-7-7s3.133-7 7-7 7 3.133 7 7-3.133 7-7 7z",
    fill: props.fill
  }));
}
export default SvgInfo;